import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createTeamActions } from './actions';
import { TeamActions, TeamState } from './types';

export const useTeamStore = create<TeamState & TeamActions>()(
    immer((set, get, store) => ({
        teams: [],
        loading: false,
        selectedTeam: null,
        loadingTeam: false,
        error: undefined,
        ...createTeamActions(set, get, store),
    })),
);
